import { render } from "./MoreProjects.vue?vue&type=template&id=9adc1fa2&scoped=true"
import script from "./MoreProjects.vue?vue&type=script&lang=js"
export * from "./MoreProjects.vue?vue&type=script&lang=js"

import "./MoreProjects.vue?vue&type=style&index=0&id=9adc1fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9adc1fa2"]])

export default __exports__